module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "toc",
    staticStyle: {
      "padding": "2em"
    }
  }, [_c('p', {
    staticClass: "title dPurple",
    attrs: {
      "id": "i932a"
    }
  }, [_vm._v("contents")]), _vm._v(" "), _c('p', {
    staticClass: "sub",
    attrs: {
      "id": "i1220a"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Introduction"
    }
  }, [_vm._v("8\tIntroduction")])]), _vm._v(" "), _c('p', {
    staticClass: "sub",
    attrs: {
      "id": "i1220b"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Chapter1"
    }
  }, [_vm._v("11\tDeck the Halls"), _c('br'), _vm._v(" "), _c('i', [_vm._v("Designs for the Home")])])]), _vm._v(" "), _c('p', {
    staticClass: "sub",
    attrs: {
      "id": "i1220c"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("65\tWarming Up "), _c('br'), _vm._v(" "), _c('i', [_vm._v("Hats, Scarves, Mittens, Gloves, and Socks")])])]), _vm._v(" "), _c('p', {
    staticClass: "sub",
    attrs: {
      "id": "i1220d"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("107   Dressing Up"), _c('br'), _vm._v(" "), _c('i', [_vm._v("Sweaters, Shawls, and Party Hats")])])]), _vm._v(" "), _c('p', {
    staticClass: "sub",
    attrs: {
      "id": "i1220e"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("153\tPacking Up "), _c('br'), _vm._v(" "), _c('i', [_vm._v("Carryalls, Gift Bags, and Last-Minute Gifts")])])]), _vm._v(" "), _c('p', {
    staticClass: "sub2",
    attrs: {
      "id": "i1220f"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Techniques",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "ch_12"
  }, [_vm._v("176")]), _vm._v("\t   special techniques")])]), _vm._v(" "), _c('p', {
    staticClass: "sub2",
    attrs: {
      "id": "i1220f2"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/title",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "ch_12"
  }, [_vm._v("182")]), _vm._v("\t   contributors")])]), _vm._v(" "), _c('p', {
    staticClass: "sub2",
    attrs: {
      "id": "i1220f3"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Supplies",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "ch_12"
  }, [_vm._v("184")]), _vm._v("\t   sources for supplies")])]), _vm._v(" "), _c('p', {
    staticClass: "sub2",
    attrs: {
      "id": "i1220f4"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/acknowledgements",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "ch_12"
  }, [_vm._v("185")]), _vm._v("\t   acknowledgments")])]), _vm._v(" "), _c('p', {
    staticClass: "sub2",
    attrs: {
      "id": "i1220f5"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/index",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "ch_12"
  }, [_vm._v("186")]), _vm._v("\t   index")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3bbd272c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Contents.vue
// module id = 66
// module chunks = 0